<template>
<div>
    <Spinner v-if="loading" class="mt-5">{{ loadingMessage||"Loading ..."}}</Spinner>

    <div v-else class="">

        <!-- ========================== OPTIONS LIST ====================== -->
        <div v-if=" view == 'custom' " class="row mx-0">
            <p class="text-center heading mt-2" v-html="headingMessage"></p>

            <div class="payment-methods">
                <a class="" @click.prevent="pickCustomProvider(key)" v-for="(item, key) in options" :key="key">
                    <div class="method ">
                        <img :src="item.image_url" :alt="item.option" />
                        <p class="content" v-html="item.option"></p>
                    </div>
                </a>
            </div>

        </div>
        <!-- ========================== OPTIONS LIST ====================== -->

        <!-- ========================== PROVIDER ALREADY SELECTED ====================== -->
        <div v-else>
            <!-- ========================== COMING SOON ====================== -->
            <div class="text-center mt-3" v-if="current_option == null || isComingSoon">
                <!--h1 style="color: grey; width: 100%;">{{ data.option }}</-h1-->
                <img v-if="current_option.image_url" :src="current_option.image_url" class="provider-logo" alt="" style="width: 20%; height :auto" />
                <h5 style="" class="mt-3 gray">Coming Soon</h5>
                <p class="mt-3" style="font-size:14px;"> <strong>{{ current_option.option}}</strong> is under development, please use other payment method.</p>
            </div>
            <!-- ========================== COMING SOON ====================== -->

            <div v-else>

                <!-- ========================== REDIRECTION MESSAGE ====================== -->
                <div v-if="showRedirection">
                    <div class="modal-body pb-1">
                        <p class="enterotp text-center heading mt-5" style="font-size:14px;" v-html="headingMessage"></p>
                    </div>
                </div>
                <!-- ========================== REDIRECTION MESSAGE ====================== -->

                <!-- MasterPass Flow -->
                <div v-else>
                    <div class="row m-0 text-center" v-if="!showRedirection && current_option && current_option.provider && current_option.provider.toLowerCase() == 'masterpass' ">
                        <div class="row mx-0 px-2">
                            <div v-if="showMPassCards" class="col-12 px-0">
                                <div class="form-group mb-2" :key="key" v-for="(card,key) in savedCards" @click.prevent="enterMpassPin(key)">
                                    <div class="saved" @mouseover="hoverEffect(true, key)" @mouseleave="hoverEffect(false, key)" :style="{'borderColor' : (hover && hoverKey == key) ? `${client_info.colors.app}` : '' }">

                                        <a href="#" title="Remove card" @click.prevent.stop="removeMpassCard(key)" class="close"></a>

                                        <div class="title mb-1 mt-2 text-left pl-2" @mouseover="hoverEffect(true, key)" @mouseleave="hoverEffect(false, key)" :style="{'color' : (hover && hoverKey == key) ? `${client_info.colors.app}` : '' }">
                                            {{ formatCard(card.mask) }}
                                        </div>
                                        <i v-if="card.brand.toLowerCase() == 'visa'" class="visa"></i>
                                        <i v-else-if="card.brand.toLowerCase() == 'mastercard'" class="mastercard"></i>
                                        <i v-else-if="card.brand.toLowerCase() == 'verve'" class="verve"></i>
                                    </div>
                                </div>

                                <div v-if="!loading" class="text-center my-3 mt-4">
                                    <div id="new-saved" class="switch">
                                        <a @click.prevent="addMpassCard" class="left active pointer" :style="{ 'background' : `${client_info.colors.primary_button}`, 'color' : `${client_info.colors.payment_description} !important`, 'borderColor' : `${client_info.colors.app}`,}">REMOVE
                                            OR ADD NEW CARD</a>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="!showRedirection && !loading && !showMpassPin && showMpassPay" class="col-12 px-0">
                                <button type="button" class="btn app-bg-color mt-2" :style="button_color" ref="btnActionSendOtp" id="btnActionSendOtp" @click.prevent="addMpassCard" @keyup.enter="addMpassCard">Add Visa or MasterCard</button>
                            </div>

                            <!-- MasterPass Pin -->
                            <div v-if="showMpassPin" class="col-12 px-0">
                                <div class="form-group mt-3">
                                    <form class="pay-otp-code" @submit.prevent="postMpassDebit">
                                        <input type="password" class="form-control no-label text-center" @keyup.enter="postMpassDebit" v-model="mpassPin" id="pinInput" ref="pinInput" maxlength="5" autocomplete="off" minlength="4" autofocus required @focus="isFocus = true" @blur="isFocus = false" :style="{ borderColor: `${client_info.colors.app}`  }" placeholder="Enter PIN" style="letter-spacing: inherit; text-align: left" />
                                        <span class="invalid-feedback" :style="(errors.mpassPin) ? 'display : inline' : ''">{{ errors.mpassPin }}</span>
                                    </form>
                                </div>

                                <div v-if="this.savedCards.length > 0" class="form-group text-center mb-0">
                                    <a href="javascript:void(0)" class="text-tiny" @click.prevent="changeMpassCardSelect">&larr; Use another
                                        card</a>
                                </div>

                                <div class="form-group mb-0 mt-4">
                                    <button type="submit" class="btn app-bg-color" :style="button_color" ref="postMpassDebit" id="postMpassDebit" @click.prevent="postMpassDebit" @keyup.enter="postMpassDebit">Make Payment</button>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
                <!-- END MasterPass Flow -->
            </div>

        </div>
        <!-- ========================== PROVIDER ALREADY SELECTED ====================== -->

    </div>
</div>
</template>

<script>
import axios from 'axios';
import Spinner from './includes/Spinner.vue';
// import DebitCard from './includes/DebitCard.vue';
import {
    EventBus
} from './includes/bus.js';

const source = axios.CancelToken.source();
// axios.defaults.timeout = 60 * 3 * 1000;

export default {
    name: 'redirect',
    props: ['data', 'client_info', 'button_color'], // values resides here this.data.details
    components: {
        Spinner,
        // DebitCard,
    },

    created() {

        EventBus.$on('global-back', payload => {
            if (payload.in_view.toLowerCase() == 'redirect' && payload.action == "back") {
                if (this.view == "custom") {
                    this.changePaymentOption();
                } else {
                    this.goBack();
                }
            }
        });

        if (this.data) {
            // IFRAME REPLY
            // console.log(this.data.details);
            // console.log(this.data.details.custom_providers);
            /* if(this.data.details.details === undefined){
                window.failedFromStartMessage = "No provider is set for this option from the option call.";
                window.failedFromStart = false;
                let raw  = JSON.parse(window.raw);
                raw.message = "No provider is set for this option from the option call.";
                window.raw = JSON.stringify(raw);
                this.$router.push('/v2/mtn/warning');
            }else */
            if (this.data.details.source && this.data.details.source == 'iframeReply') {

                this.loadingMessage = '';

                this.loading = true;

                let transaction = this.data.details.transaction,
                    paymentMethod = this.$store.state.paymentMethodProvider;

                this.transaction = transaction;
                this.current_option = this.data.details.iframereply.provider

                if (paymentMethod == "masterpass") {
                    this.type = "masterpass"
                    this.loadingMessage = 'Checking Masterpass for your cards ..'
                    this.showRedirection = false
                    this.getMpassCard();
                } else if (paymentMethod == "ipg") {
                    this.type = "ipg"
                    this.loadingMessage = 'Validating payment ..'
                    let replyData = this.data.details.iframereply;
                    // console.log(replyData)
                    if (replyData.data.txnref != "")
                        this.pushIPGToOnepipe(replyData.data.txnref, replyData.provider);
                    else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = replyData.data.desc;
                        let raw = JSON.parse(window.raw)
                        raw.message = replyData.data.desc
                        window.raw = JSON.stringify(raw);
                        this.$router.push('/v2/mtn/warning');
                        return;
                    }
                } else if (paymentMethod == "paystack") {
                    this.type = "paystack"
                    this.loadingMessage = 'Validating payment ..'
                    let replyData = this.data.details.iframereply;
                    if (replyData.data.reference != "undefined" || replyData.data.reference != null) {
                        this.pushPaystackToOnepipe(replyData.data.reference || replyData.data.trxref, replyData
                            .provider)
                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage =
                            "Paystack payment reference is missing. On your console, ensure your callback_url has a get parameter like this <strong>?provider=paystack</strong>";
                        let raw = JSON.parse(window.raw)
                        raw.message = replyData.data.desc
                        window.raw = JSON.stringify(raw);
                        this.$router.push('/v2/mtn/warning');
                    }
                }
            } else { // IFRAME 
                // let options = this.data.details.custom_providers;
                let options = this.data.details.custom_providers;
                this.transaction = this.data.details.transaction

                if (this.data.details.channels[this.data.details.index].action.length === 0) {
                    this.options = null;
                    return;
                }

                if (!options) { // Only One Provider
                    this.view == 'others';
                    this.providers = this.data.details.channels[0];
                    this.current_option = this.data.details.details;
                    this.type = this.current_option.provider.toLowerCase();
                    this.redirectUrl = this.current_option.custom_ui_url

                    if (this.current_option.instructions != "")
                        this.loading = false;

                    // if(this.data.details.channels.length === 0){
                    //     this.options = null;
                    //     return;
                    // }

                    this.handleChosenProvider(this.type);

                } else if (options && Object.keys(this.data.details).includes(
                        "details")) { //coming from default view
                    this.current_option = this.data.details.details;
                    this.type = this.current_option.provider.toLowerCase();
                    this.redirectUrl = this.current_option.custom_ui_url

                    if (this.current_option.instructions != "")
                        this.loading = false;

                    this.handleChosenProvider(this.type);
                } else { // Has multiple custom ui providers
                    this.view = 'custom';
                    this.options = options;
                    this.headingMessage = this.data.details.channels[this.data.details.index].message
                    this.loading = false;
                    this.loading = false;
                }
            }
        }

    },

    watch: {
        view(val) {
            this.view = val
        },
        setActive(index) {
            this.active = index
        },
        redirectUrl(val) {
            this.redirectUrl = val
        },
        transaction(val) {
            this.transaction = val
        },
        isFocus(newVal) {
            if (newVal)
                this.focusColor = this.appColor
        }
    },
    data() {
        return {
            isComingSoon: false,
            focusColor: '',
            redirectUrl: '',
            mpassPin: '',
            view: '',
            current_option: {},
            paystack: {
                access_code: '',
                reference: '',
                authorization_url: '',
            },
            options: [],
            headingMessage: '',
            transaction: {},
            savedCards: [],
            selectedCard: {},
            details: {},
            showMpassPay: false,
            appColor: '',
            isFocus: true,
            showMPassCards: false,
            showMpassPin: false,
            countDownSeconds: 2,
            providers: [],
            provider: {},
            hoverKey: 0,
            hover: false,
            type: '',
            loadingMessage: 'Loading...',
            loading: false,
            errors: {},
            showRedirection: false,
        }
    },
    methods: {
        goBack() {
            this.$emit('handleTitle', this.data.details.channels[this.data.details.index].title);
            this.view = 'custom'
            this.isComingSoon = false;
            this.headingMessage = this.data.details.message
            this.current_option = ''
            this.show_bank_list = false;
            this.isOTP = true;
            if (this.loading)
                this.loading = false
        },

        changePaymentOption() {
            if (this.loading)
                this.loading = false
            // Cancel countdown
            clearInterval(window.countDown);
            this.$parent.changeComponent("PaymentOptions");
        },

        pickCustomProvider(index) {
            this.current_option = this.options[index];
            this.view = 'others';
            this.handleChosenProvider(this.current_option.provider);
        },

        transactCall(secure, type) {

            try {

                this.loading = true;
                this.headingMessage = '';
                this.mPassLoadingMessage = "Initializing transaction ...";

                let initialPayload = this.$store.state.payload,
                    payload = {
                    request_ref: initialPayload.request_ref,
                    request_type: initialPayload.request_type,
                    auth: {
                        "type": "custom",
                        "secure": secure,
                        "auth_provider": this.current_option.provider,
                    },
                    transaction: initialPayload.transaction
                }

                // Add customer_processing_fees
                if (this.$store.state.customer_processing_fee) {
                    payload.transaction.amount = parseInt(payload.transaction.amount) + parseInt(this.$store.state.customer_processing_fee.toString().replace('.', ''));
                }

                payload.transaction.transaction_ref = this.$store.state.transRef

                if (this.$store.state.isFailed)
                    payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

                let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: payload
                },
                data = this.$generateToken(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: `Bearer ${this.$store.state.payload.api_key}`
                    }
                }).then(( {data}) => {
                    this.isLoading = false;
                    this.loadingMessage = 'Loading.. please wait';
                    let hash = data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    // Go and do the auto close popup on the status page instead of every pages.. it's more descent that way
                    if (status == "successful") {

                        this.isLoading = false;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transaction.transaction_ref,
                            type: 'Successful',
                            data: responseData,
                            message: message || res.data.message
                        });

                    } else if (status === "processing") {

                        if (type == 'ipg') {
                            setTimeout(() => {
                                this.loading = true;
                                this.mPassLoadingMessage = "Initializing transaction ..."
                                setTimeout(() => {
                                    this.redirectTimer(data = {
                                        formData: responseData.provider_response.meta.formData,
                                        chargeUrl: responseData.provider_response.meta.formData.charge_url
                                    });
                                }, 2000);
                            }, 4000);
                        } else if (type == 'paystack') {

                            setTimeout(() => {
                                this.loading = true;
                                this.mPassLoadingMessage = "Initializing transaction ..."
                                setTimeout(() => {
                                    // Url is already been sent back from the Provider
                                    this.getPaystackPaymentUrl();
                                }, 2000);
                            }, 4000);

                        } else {
                            console.log(type);
                        }

                    } else {
                        window.failedFromStart = false;
                        window.failedFromStartMessage = message || "Payment Failed."
                        this.$router.push('/v2/mtn/warning');
                    }
                }).catch(err => {
                    console.log(err)
                    window.raw = JSON.stringify(err);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = err;
                    this.$router.push('/v2/mtn/warning');
                })
            } catch (err) {
                console.log(`Call OnePipe Error ${err}`)
                window.raw = JSON.stringify(err);
                window.failedFromStart = false;
                window.failedFromStartMessage = err;
                this.$router.push('/v2/mtn/warning');
            }

        },

        handleChosenProvider(provider) {
            this.type = provider.toLowerCase();
            this.$store.dispatch('paymentMethodProvider', this.type)

            switch (provider.toLowerCase()) {
                case "comingsoon":
                    this.headingMessage = "";
                    this.$emit('handleTitle', this.current_option.option);
                    this.isComingSoon = true;
                    break;
                case "masterpass":
                    this.$emit('handleTitle', this.current_option.option);
                    if (this.current_option.instructions && this.current_option.instructions != "")
                        this.headingMessage = this.current_option.instructions
                    else
                        this.headingMessage = 'Checking Masterpass for your cards ..'
                    this.showRedirection = false

                    setTimeout(() => {
                        this.loading = true;
                        this.loadingMessage = "Checking Masterpass for your cards .."
                        setTimeout(() => {
                            this.getMpassCard();
                        }, 2000);
                    }, 3000);

                    break;

                case "paystack":
                    this.$emit('handleTitle', this.current_option.option);
                    this.showRedirection = true;

                    if (this.current_option.instructions && this.current_option.instructions != "")
                        this.headingMessage = this.current_option.instructions
                    else {
                        this.headingMessage = "Initializing transaction ..."
                    }

                    setTimeout(() => {
                        this.loading = true;
                        this.loadingMessage = "Initializing transaction ..."
                        setTimeout(() => {
                            this.getPaystackPaymentUrl();
                            // this.transactCall(null, 'paystack');
                        }, 2000);
                    }, 3000);
                    // return;
                    break;

                case "ipg":
                case "verve":
                    this.$emit('handleTitle', this.current_option.option);
                    this.showRedirection = true;

                    if (this.current_option.instructions && this.current_option.instructions != "")
                        this.headingMessage = this.current_option.instructions || "Initializing transaction ..."
                    else {
                        this.headingMessage = "Initializing transaction ..."
                    }

                    setTimeout(() => {
                        this.loading = true;
                        this.headingMessage = '';
                        this.mPassLoadingMessage = "Initializing transaction ..."
                        setTimeout(() => {
                            this.headingMessage = ""
                            this.transactCall(null, 'ipg');
                        }, 2000);

                    }, 3000);

                    break;

                default:
                    // Auto Submit
                    this.loading = false
                    this.showRedirection = true;
                    break;
            }
        },

        changeMpassCardSelect() {
            this.headingMessage = this.loadingMessage = "YOUR CARDS"
            this.selectedCard = {};
            this.showMpassPin = false;
            this.showMPassCards = true;
        },
        hoverEffect(value, key) {
            this.hover = value
            this.hoverKey = key
        },
        formatCard(str) {
            str = str.toUpperCase();
            let prefix = str.slice(0, 4),
                prefix2 = str.slice(4, 8),
                suffix = str.slice(10),
                main = `${prefix} ${prefix2} XXXX ${suffix}`;
            return main;
        },
        addMpassCard() {
            this.loading = true;
            this.showMPassCards = false;
            this.requestMpassUserWallet(this.transaction.customer.mobile_no);
        },
        enterMpassPin(index) {
            this.headingMessage = this.loadingMessage = "Enter your Masterpass Digital Wallet PIN"
            this.selectedCard = this.savedCards[index];
            this.showMPassCards = false;
            this.showMpassPin = true;
        },
        removeMpassCard() {
            if (!confirm("Are you sure?"))
                return;
            this.showMpassPin = false;
            this.loading = true;
            this.showMPassCards = false;
            this.requestMpassUserWallet(this.transaction.customer.mobile_no);
        },

        pushIPGToOnepipe(ref, provider) {

            let intialPayload = this.$store.state.payload,
                payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: intialPayload.request_type,
                    auth: {
                        type: 'custom',
                        secure: ref, //  IPG trxn ref
                        auth_provider: provider.provider
                    },
                    transaction: {
                        transaction_ref: this.$store.state.transRef,
                    }
                };

            if (this.$store.state.customer_processing_fee && parseFloat(this.$store.state.customer_processing_fee) > 0) {
                let cleanExtraCharges = this.$store.state.customer_processing_fee.toString().replace('.', '');
                payload.transaction.amount = (parseFloat(payload.transaction.amount) + parseFloat(cleanExtraCharges)).toString().replace('.', '');
            }

            if (this.$store.state.isFailed)
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

            // Customer PRecessing Fee
            if (Object.keys(this.current_option).includes('extras') && this.current_option.extras != null) {
                if (this.current_option.extras.customer_processing_fee_flat && parseFloat(this.current_option.extras
                        .customer_processing_fee_flat) > 0) {
                    let fees = parseFloat(this.current_option.extras.customer_processing_fee_flat).toFixed(2).replace('.', '');
                    payload.transaction.amount = parseFloat(payload.transaction.amount) + parseFloat(fees)
                } else if (this.current_option.extras.customer_processing_fee_percentage && parseFloat(this
                        .current_option.extras.customer_processing_fee_percentage) > 0) {
                    let percentage_price_as_flat = ((parseFloat(this.$store.state.payload.transaction.amount) /
                        100) * (parseFloat(this.current_option.extras.customer_processing_fee_percentage) / 100)).toFixed(2).replace('.', '')
                    payload.transaction.amount = parseFloat(payload.transaction.amount) + parseFloat(percentage_price_as_flat);
                }
            }

            // Get status and show it to user
            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'query',
                payload
            };

            delete payload.api_key

            let data = this.$generateToken(data2);


            if (this.$store.state.isFailed)
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: `Bearer ${this.$store.state.payload.api_key}`
                    }
                }).then(response => {
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    window.raw = JSON.stringify(res);

                    if (response.status === 200) {
                        if (status == "successful") {
                            this.loading = false;

                            this.$parent.changeComponent('Status', {
                                reference: payload.transRef,
                                type: 'Successful',
                                data: responseData,
                                message: message || res.data.message
                            });

                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        },

        redirectTimer(data = null) {

            window.countDown = setInterval(() => {
                this.countDownSeconds--
                if (this.countDownSeconds <= 0) {
                    clearInterval(window.countDown);
                    let response = {};

                    if (this.type == 'ipg' || this.type == 'verve' || this.type == 'webpaydirect') {
                        response = {
                            'status': 'redirect',
                            'data': {
                                'form': data,
                                'transaction': this.transaction,
                                'redirectUrl': window.location.hostname == "localhost" ?
                                    'http://redirect.md/' : this.current_option.custom_ui_url ?
                                    this.current_option.custom_ui_url : "https://customui.dev.onepipe.io/",
                                'siteRedirectUrl': window.location.hostname == "localhost" ?
                                    'http://redirect.md/redirect-status.php' : this.current_option
                                    .extras.callback_url ? this.current_option.extras.callback_url : "https://customui.dev.onepipe.io/redirect-status.php",
                                'chargeUrl': data.chargeUrl,
                                'sourceUrl': window.location.hostname == "localhost" ?
                                    'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                                'provider': this.current_option,
                            }
                        }
                    } else if (this.type == 'masterpass') {
                        response = {
                            'status': 'redirect',
                            'data': {
                                'transaction': this.transaction,
                                'redirectUrl': window.location.hostname === 'localhost' ?
                                    'http://redirect.md/' : this.current_option.custom_ui_url,
                                'chargeUrl': data.iframeUrl || this.current_option.custom_ui_url +
                                    '/redirect.php',
                                'sourceUrl': window.location.hostname === 'localhost' ?
                                    'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                                'provider': this.current_option,
                            }
                        }

                    } else if (this.type == 'paystack') {
                        response = {
                            'status': 'redirect',
                            'data': {
                                'transaction': this.transaction,
                                'redirectUrl': window.location.hostname === 'localhost' ?
                                    'http://redirect.md/' : this.current_option.custom_ui_url,
                                "callback_url": window.location.hostname === 'localhost' ?
                                    'http://redirect.md/' : this.current_option.extras
                                    .callback_url,
                                'chargeUrl': data.iframeUrl,
                                'sourceUrl': window.location.hostname === 'localhost' ?
                                    'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                                'provider': this.current_option,
                            }
                        }

                    }

                    // console.log(response);
                    // delete response.current_option.extras

                    this.$parent.componentId = "";
                    window.parent.postMessage(JSON.stringify(response), '*');

                    // Unmount Component so that it can re-access the created function again.
                    this.$parent.in_view = '';
                }
            }, 1000);
        },

        cancel() {
            clearInterval(window.countDown);
        },

        getPaystackPaymentUrl() {
            if (this.transaction.customer.email == "null") {
                this.loading = false;
                window.failedFromStart = false;
                window.failedFromStartMessage = "Please supply a valid email in your payload";
                this.$router.push('/v2/mtn/warning');
                return;
            }

            axios.post("https://api.paystack.co/transaction/initialize", {
                    email: this.transaction.customer.email,
                    callback_url: window.location.hostname === 'localhost' ?
                        'http://redirect.md/redirect-status.php?provider=paystack' : this.current_option
                        .extras.callback_url,
                    amount: this.transaction.amount,
                    reference: this.$store.state.transRef,
                    meta: {
                        custom_fields: [{
                            display_name: this.transaction.customer.firstname + ' ' + this.transaction
                                .customer.surname,
                            variable_name: "mobile_number",
                            value: this.transaction.customer.mobile_no
                        }]
                    }
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${this.current_option.extras.paystack_secret_key}`,
                        'cache-control': 'no-cache',
                    },
                    cancelToken: source.token
                }).then(response => {
                    if (response.status === 200) {
                        var res = response.data;
                        window.raw = JSON.stringify(res.data);

                        // this.loading = false;
                        if (res.status) {
                            this.paystack = res.data
                            this.redirectTimer({
                                iframeUrl: res.data.authorization_url,
                            });

                            this.loadingMessage = "Waiting for response";
                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else if (response.status === 400) {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = response.data.message;
                        this.$router.push('/v2/mtn/warning');
                    } else {
                        // console.log(response);
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    // console.error(error);
                    window.raw = JSON.stringify({
                        status: 'Failed',
                        message: error.response.data.message
                    }) || JSON.stringify(error);
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })

            // source.cancel('Operation canceled by the user.');
        },

        pushPaystackToOnepipe(ref, provider) {
            let randomId = this.$generateRequestRef(),
                payload = this.$store.state.payload;

            payload.auth = {
                type: 'custom',
                secure: ref, //  Paystack trxn ref
                auth_provider: provider.provider
            }

            payload.transaction.transaction_ref = this.$store.state.transRef;
            payload.request_ref = randomId; // generate a new ref to call Onepipe.

            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'transact',
                payload
            };

            delete payload.api_key

            let data = this.$generateToken(data2);

            if (this.$store.state.isFailed)
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                }).then(response => {
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    window.raw = JSON.stringify(res);

                    if (response.status === 200) {

                        if (status == "successful") {
                            this.loading = false;
                            this.$parent.changeComponent('Status', {
                                reference: payload.transRef,
                                type: 'Successful',
                                message: message || res.data.message,
                                data: responseData,
                            });

                        } else if (status == "waitingforotp") {
                            this.loading = false;
                            this.view = 'otp'
                            this.headingMessage = message || `Enter otp sent to ${this.$maskPhone(this.msisdn)}`
                            return;

                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        },

        getMpassCard() {

            // Call Lookup cards to fetch user's card

            let url = "https://masterpass.bits.dev.onepipe.io/get-cards";
            axios.post(url, {
                    user_id: this.transaction.customer.mobile_no,
                    hash: this.current_option.extras.api_key,
                    user_id_type: this.current_option.extras.user_id_type,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer ' + this.$store.state.payload.api_key
                    }
                })

                /* axios({
                method: 'post',
                url,
                timeout: 1000,
                data: {
                    user_id: this.transaction.customer.mobile_no,
                    api_key: this.current_option.extras.api_key,
                    user_id_type: this.current_option.extras.user_id_type,
                },
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }) */

                .then(response => {
                    if (response.status === 200) {
                        var res = response.data;
                        // console.log(res)
                        window.raw = JSON.stringify(res.data);

                        this.loading = false;

                        if (res.status.toLowerCase() == "successful") {
                            if (res.data.provider_response.cards.length > 0) {
                                this.loading = false;
                                this.headingMessage = "YOUR CARDS";
                                this.savedCards = res.data.provider_response.cards;
                                this.view = 'others';
                                this.showMPassCards = true
                                this.showMpassPay = false
                                this.activeCardView = 1

                            } else {
                                this.showMPassCards = false
                                this.showMpassPay = true
                                this.loadingMessage =
                                    `This service is made possible by ${this.current_option.provider}. Because this is your first time, you may be required to set up a 5-digit PIN for your future security`;
                                // this.requestMpassUserWallet(this.transaction.customer.mobile_no);
                            }

                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(() => {
                    // console.warn(error);
                    let newRaw = JSON.parse(window.raw);
                    // console.log(newRaw);
                    newRaw.data.message = 'An error occured while fetching cards';
                    window.raw = JSON.stringify(newRaw);
                    window.failedFromStartMessage = 'An error occured while fetching cards';
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        },

        requestMpassUserWallet() {
            this.loadingMessage = "You'll be redirected to Masterpass page."
            let url = "https://masterpass.bits.dev.onepipe.io/get-wallet";
            let payload = {
                user_id: this.transaction.customer.mobile_no,
                hash: this.current_option.extras.api_key,
                user_id_type: this.current_option.extras.user_id_type,
                redirect_url: 'https://customui.dev.onepipe.io/redirect-status.php'
            };

            axios.post(url, payload, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                }).then(response => {
                    if (response.status === 200) {
                        var res = response.data;
                        // console.log(res)
                        window.raw = JSON.stringify(res.data);

                        if (res.status.toLowerCase() == "successful") {
                            if (res.data.provider_response.result.toLowerCase() === "success") {
                                // Prepare for redirect
                                this.redirectTimer({
                                    iframeUrl: res.data.provider_response.url,
                                });

                                this.loadingMessage = "Waiting for response";
                            } else {
                                // Show error
                                this.loading = false;
                                window.failedFromStart = false;
                                window.failedFromStartMessage = res.message;
                                this.$router.push('/v2/mtn/warning');
                            }

                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        },
        postMpassDebit() {
            if (this.mpassPin.length <= 0) {
                this.errors.mpassPin = true;
                this.otp_error_message = "Please supply your wallet pin code.";
                this.$refs.otpInput.focus();
                return;
            }

            this.loading = true;
            this.showMpassPin = false;

            this.loadingMessage = "Validating to debit your wallet..."

            // let initialPayload = this.$parent.getInitialPayload(),
            let randomId = this.$generateRequestRef(),
                payload = this.$store.state.payload;
            payload.auth = {
                type: 'custom',
                secure: `${this.transaction.customer.mobile_no};${this.selectedCard.cardId};${this.mpassPin.toString()}`, // customerId;cardId;pin
                auth_provider: this.current_option.provider
            }

            payload.request_ref = randomId; // generate a new ref to call Onepipe.
            // Get status and show it to user
            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'transact',
                payload
            };

            delete payload.api_key

            // if (this.$store.state.isFailed)
            data2.payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef;

            data2.payload.transaction.transaction_ref = this.$store.state.transRef;

            let data = this.$generateToken(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    },
                    cancelToken: source.token
                }).then(response => {
                    if (response.status === 200) {

                        let hash = response.data.data,
                            res = this.$decodeToken(hash),
                            status = res.status.toLowerCase(),
                            message = res.message,
                            responseData = res.data;

                        // console.log(res)
                        window.raw = JSON.stringify(res);

                        if (status == "successful") { // Check if user set autoclose for this payment method.
                            this.$parent.changeComponent('Status', {
                                // reference: payload.transaction.transaction_ref,
                                type: 'Successful',
                                status: 'Successful',
                                message: message || res.data.message,
                                data: responseData,
                            });

                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('/v2/mtn/warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    // console.log(error.code);
                    // console.log(error.message);
                    // console.log(error.stack);
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })

            // source.cancel('Operation canceled by the user.');
        },
    }
};
</script>
